var $kJQf8$reactariagrid = require("@react-aria/grid");
var $kJQf8$reactarialiveannouncer = require("@react-aria/live-announcer");
var $kJQf8$reactariautils = require("@react-aria/utils");
var $kJQf8$react = require("react");
var $kJQf8$reactstatelyflags = require("@react-stately/flags");
var $kJQf8$reactariai18n = require("@react-aria/i18n");
var $kJQf8$reactstatelycollections = require("@react-stately/collections");
var $kJQf8$reactariafocus = require("@react-aria/focus");
var $kJQf8$reactariainteractions = require("@react-aria/interactions");
var $kJQf8$reactariavisuallyhidden = require("@react-aria/visually-hidden");
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
$parcel$export(module.exports, "useTableRowGroup", () => $cd66afe5decb6adb$export$6fb1613bd7b28198);
$parcel$export(module.exports, "useTable", () => $25d14c0f8fad722e$export$25bceaac3c7e4dc7);
$parcel$export(module.exports, "useTableColumnHeader", () => $7669c34a63ef0113$export$9514819a8c81e960);
$parcel$export(module.exports, "useTableRow", () => $10b2115217af7c93$export$7f2f6ae19e707aa5);
$parcel$export(module.exports, "useTableHeaderRow", () => $eb16c38321a72835$export$1b95a7d2d517b841);
$parcel$export(module.exports, "useTableCell", () => $32387a1f2c61cda2$export$49571c903d73624c);
$parcel$export(module.exports, "useTableSelectionCheckbox", () => $0b394e4562ac57c9$export$16ea7f650bd7c1bb);
$parcel$export(module.exports, "useTableSelectAllCheckbox", () => $0b394e4562ac57c9$export$1003db6a7e384b99);
$parcel$export(module.exports, "useTableColumnResize", () => $16d645f9e2153641$export$52994e973806c219);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
    * Copyright 2020 Adobe. All rights reserved.
    * This file is licensed to you under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License. You may obtain a copy
    * of the License at http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software distributed under
    * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
    * OF ANY KIND, either express or implied. See the License for the specific language
    * governing permissions and limitations under the License.
    */

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
const $6acf696f746f932c$export$552312adfd451dab = new WeakMap();
function $6acf696f746f932c$var$normalizeKey(key) {
  if (typeof key === "string") return key.replace(/\s*/g, "");
  return "" + key;
}
function $6acf696f746f932c$export$37cd4213f2ad742e(state, columnKey) {
  let gridId = $6acf696f746f932c$export$552312adfd451dab.get(state);
  if (!gridId) throw new Error("Unknown grid");
  return "".concat(gridId, "-").concat($6acf696f746f932c$var$normalizeKey(columnKey));
}
function $6acf696f746f932c$export$19baff3266315d44(state, rowKey, columnKey) {
  let gridId = $6acf696f746f932c$export$552312adfd451dab.get(state);
  if (!gridId) throw new Error("Unknown grid");
  return "".concat(gridId, "-").concat($6acf696f746f932c$var$normalizeKey(rowKey), "-").concat($6acf696f746f932c$var$normalizeKey(columnKey));
}
function $6acf696f746f932c$export$85069b70317f543(state, rowKey) {
  // A row is labelled by it's row headers.
  return [...state.collection.rowHeaderColumnKeys].map(columnKey => $6acf696f746f932c$export$19baff3266315d44(state, rowKey, columnKey)).join(" ");
}
var $7ff3f66df3873a5e$exports = {};
var $ca0f93ae476efcee$exports = {};
$ca0f93ae476efcee$exports = {
  "ascending": "\u062A\u0635\u0627\u0639\u062F\u064A",
  "ascendingSort": args => "\u062A\u0631\u062A\u064A\u0628 \u062D\u0633\u0628 \u0627\u0644\u0639\u0645\u0648\u062F ".concat(args.columnName, " \u0628\u062A\u0631\u062A\u064A\u0628 \u062A\u0635\u0627\u0639\u062F\u064A"),
  "columnSize": args => "".concat(args.value, " \u0628\u0627\u0644\u0628\u0643\u0633\u0644"),
  "descending": "\u062A\u0646\u0627\u0632\u0644\u064A",
  "descendingSort": args => "\u062A\u0631\u062A\u064A\u0628 \u062D\u0633\u0628 \u0627\u0644\u0639\u0645\u0648\u062F ".concat(args.columnName, " \u0628\u062A\u0631\u062A\u064A\u0628 \u062A\u0646\u0627\u0632\u0644\u064A"),
  "resizerDescription": "\u0627\u0636\u063A\u0637 \u0639\u0644\u0649 \u0645\u0641\u062A\u0627\u062D Enter \u0644\u0628\u062F\u0621 \u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u062D\u062C\u0645",
  "select": "\u062A\u062D\u062F\u064A\u062F",
  "selectAll": "\u062A\u062D\u062F\u064A\u062F \u0627\u0644\u0643\u0644",
  "sortable": "\u0639\u0645\u0648\u062F \u0642\u0627\u0628\u0644 \u0644\u0644\u062A\u0631\u062A\u064A\u0628"
};
var $8fcf86b24fd399a9$exports = {};
$8fcf86b24fd399a9$exports = {
  "ascending": "\u0432\u044A\u0437\u0445\u043E\u0434\u044F\u0449",
  "ascendingSort": args => "\u0441\u043E\u0440\u0442\u0438\u0440\u0430\u043D\u043E \u043F\u043E \u043A\u043E\u043B\u043E\u043D\u0430 ".concat(args.columnName, " \u0432\u044A\u0432 \u0432\u044A\u0437\u0445\u043E\u0434\u044F\u0449 \u0440\u0435\u0434"),
  "columnSize": args => "".concat(args.value, " \u043F\u0438\u043A\u0441\u0435\u043B\u0430"),
  "descending": "\u043D\u0438\u0437\u0445\u043E\u0434\u044F\u0449",
  "descendingSort": args => "\u0441\u043E\u0440\u0442\u0438\u0440\u0430\u043D\u043E \u043F\u043E \u043A\u043E\u043B\u043E\u043D\u0430 ".concat(args.columnName, " \u0432 \u043D\u0438\u0437\u0445\u043E\u0434\u044F\u0449 \u0440\u0435\u0434"),
  "resizerDescription": "\u041D\u0430\u0442\u0438\u0441\u043D\u0435\u0442\u0435 \u201EEnter\u201C, \u0437\u0430 \u0434\u0430 \u0437\u0430\u043F\u043E\u0447\u043D\u0435\u0442\u0435 \u0434\u0430 \u043F\u0440\u0435\u043E\u0440\u0430\u0437\u043C\u0435\u0440\u044F\u0432\u0430\u0442\u0435",
  "select": "\u0418\u0437\u0431\u0435\u0440\u0435\u0442\u0435",
  "selectAll": "\u0418\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u0432\u0441\u0438\u0447\u043A\u043E",
  "sortable": "\u0441\u043E\u0440\u0442\u0438\u0440\u0430\u0449\u0430 \u043A\u043E\u043B\u043E\u043D\u0430"
};
var $146712099a722811$exports = {};
$146712099a722811$exports = {
  "ascending": "vzestupn\u011B",
  "ascendingSort": args => "\u0159azeno vzestupn\u011B podle sloupce ".concat(args.columnName),
  "columnSize": args => "".concat(args.value, " pixel\u016F"),
  "descending": "sestupn\u011B",
  "descendingSort": args => "\u0159azeno sestupn\u011B podle sloupce ".concat(args.columnName),
  "resizerDescription": "Stisknut\xEDm kl\xE1vesy Enter za\u010Dnete m\u011Bnit velikost",
  "select": "Vybrat",
  "selectAll": "Vybrat v\u0161e",
  "sortable": "sloupec s mo\u017Enost\xED \u0159azen\xED"
};
var $2735c96991aebe53$exports = {};
$2735c96991aebe53$exports = {
  "ascending": "stigende",
  "ascendingSort": args => "sorteret efter kolonne ".concat(args.columnName, " i stigende r\xE6kkef\xF8lge"),
  "columnSize": args => "".concat(args.value, " pixels"),
  "descending": "faldende",
  "descendingSort": args => "sorteret efter kolonne ".concat(args.columnName, " i faldende r\xE6kkef\xF8lge"),
  "resizerDescription": "Tryk p\xE5 Enter for at \xE6ndre st\xF8rrelse",
  "select": "V\xE6lg",
  "selectAll": "V\xE6lg alle",
  "sortable": "sorterbar kolonne"
};
var $d85ed0c826146b1e$exports = {};
$d85ed0c826146b1e$exports = {
  "ascending": "aufsteigend",
  "ascendingSort": args => "sortiert nach Spalte ".concat(args.columnName, " in aufsteigender Reihenfolge"),
  "columnSize": args => "".concat(args.value, " Pixel"),
  "descending": "absteigend",
  "descendingSort": args => "sortiert nach Spalte ".concat(args.columnName, " in absteigender Reihenfolge"),
  "resizerDescription": "Eingabetaste zum Starten der Gr\xF6\xDFen\xE4nderung dr\xFCcken",
  "select": "Ausw\xE4hlen",
  "selectAll": "Alles ausw\xE4hlen",
  "sortable": "sortierbare Spalte"
};
var $1aecf8df24cd2c6e$exports = {};
$1aecf8df24cd2c6e$exports = {
  "ascending": "\u03B1\u03CD\u03BE\u03BF\u03C5\u03C3\u03B1",
  "ascendingSort": args => "\u03B4\u03B9\u03B1\u03BB\u03BF\u03B3\u03AE \u03B1\u03BD\u03AC \u03C3\u03C4\u03AE\u03BB\u03B7 ".concat(args.columnName, " \u03C3\u03B5 \u03B1\u03CD\u03BE\u03BF\u03C5\u03C3\u03B1 \u03C3\u03B5\u03B9\u03C1\u03AC"),
  "columnSize": args => "".concat(args.value, " pixel"),
  "descending": "\u03C6\u03B8\u03AF\u03BD\u03BF\u03C5\u03C3\u03B1",
  "descendingSort": args => "\u03B4\u03B9\u03B1\u03BB\u03BF\u03B3\u03AE \u03B1\u03BD\u03AC \u03C3\u03C4\u03AE\u03BB\u03B7 ".concat(args.columnName, " \u03C3\u03B5 \u03C6\u03B8\u03AF\u03BD\u03BF\u03C5\u03C3\u03B1 \u03C3\u03B5\u03B9\u03C1\u03AC"),
  "resizerDescription": "\u03A0\u03B1\u03C4\u03AE\u03C3\u03C4\u03B5 Enter \u03B3\u03B9\u03B1 \u03AD\u03BD\u03B1\u03C1\u03BE\u03B7 \u03C4\u03B7\u03C2 \u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2 \u03BC\u03B5\u03B3\u03AD\u03B8\u03BF\u03C5\u03C2",
  "select": "\u0395\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE",
  "selectAll": "\u0395\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE \u03CC\u03BB\u03C9\u03BD",
  "sortable": "\u03A3\u03C4\u03AE\u03BB\u03B7 \u03B4\u03B9\u03B1\u03BB\u03BF\u03B3\u03AE\u03C2"
};
var $8629e38d73986227$exports = {};
$8629e38d73986227$exports = {
  "select": "Select",
  "selectAll": "Select All",
  "sortable": "sortable column",
  "ascending": "ascending",
  "descending": "descending",
  "ascendingSort": args => "sorted by column ".concat(args.columnName, " in ascending order"),
  "descendingSort": args => "sorted by column ".concat(args.columnName, " in descending order"),
  "columnSize": args => "".concat(args.value, " pixels"),
  "resizerDescription": "Press Enter to start resizing"
};
var $219ef73190fd7b54$exports = {};
$219ef73190fd7b54$exports = {
  "ascending": "de subida",
  "ascendingSort": args => "ordenado por columna ".concat(args.columnName, " en orden de subida"),
  "columnSize": args => "".concat(args.value, " p\xEDxeles"),
  "descending": "de bajada",
  "descendingSort": args => "ordenado por columna ".concat(args.columnName, " en orden de bajada"),
  "resizerDescription": "Pulse Intro para empezar a redimensionar",
  "select": "Seleccionar",
  "selectAll": "Seleccionar todos",
  "sortable": "columna ordenable"
};
var $28e4d12b64c559fe$exports = {};
$28e4d12b64c559fe$exports = {
  "ascending": "t\xF5usev j\xE4rjestus",
  "ascendingSort": args => "sorditud veeru j\xE4rgi ".concat(args.columnName, " t\xF5usvas j\xE4rjestuses"),
  "columnSize": args => "".concat(args.value, " pikslit"),
  "descending": "laskuv j\xE4rjestus",
  "descendingSort": args => "sorditud veeru j\xE4rgi ".concat(args.columnName, " laskuvas j\xE4rjestuses"),
  "resizerDescription": "Suuruse muutmise alustamiseks vajutage klahvi Enter",
  "select": "Vali",
  "selectAll": "Vali k\xF5ik",
  "sortable": "sorditav veerg"
};
var $d443cdd0bb14863a$exports = {};
$d443cdd0bb14863a$exports = {
  "ascending": "nouseva",
  "ascendingSort": args => "lajiteltu sarakkeen ".concat(args.columnName, " mukaan nousevassa j\xE4rjestyksess\xE4"),
  "columnSize": args => "".concat(args.value, " pikseli\xE4"),
  "descending": "laskeva",
  "descendingSort": args => "lajiteltu sarakkeen ".concat(args.columnName, " mukaan laskevassa j\xE4rjestyksess\xE4"),
  "resizerDescription": "Aloita koon muutos painamalla Enter-n\xE4pp\xE4int\xE4",
  "select": "Valitse",
  "selectAll": "Valitse kaikki",
  "sortable": "lajiteltava sarake"
};
var $e7b61bd0e93b97c5$exports = {};
$e7b61bd0e93b97c5$exports = {
  "ascending": "croissant",
  "ascendingSort": args => "tri\xE9 en fonction de la colonne\xA0".concat(args.columnName, " par ordre croissant"),
  "columnSize": args => "".concat(args.value, "\xA0pixels"),
  "descending": "d\xE9croissant",
  "descendingSort": args => "tri\xE9 en fonction de la colonne\xA0".concat(args.columnName, " par ordre d\xE9croissant"),
  "resizerDescription": "Appuyez sur Entr\xE9e pour commencer le redimensionnement.",
  "select": "S\xE9lectionner",
  "selectAll": "S\xE9lectionner tout",
  "sortable": "colonne triable"
};
var $b09d12ffa0a56a3e$exports = {};
$b09d12ffa0a56a3e$exports = {
  "ascending": "\u05E2\u05D5\u05DC\u05D4",
  "ascendingSort": args => "\u05DE\u05D5\u05D9\u05DF \u05DC\u05E4\u05D9 \u05E2\u05DE\u05D5\u05D3\u05D4 ".concat(args.columnName, " \u05D1\u05E1\u05D3\u05E8 \u05E2\u05D5\u05DC\u05D4"),
  "columnSize": args => "".concat(args.value, " \u05E4\u05D9\u05E7\u05E1\u05DC\u05D9\u05DD"),
  "descending": "\u05D9\u05D5\u05E8\u05D3",
  "descendingSort": args => "\u05DE\u05D5\u05D9\u05DF \u05DC\u05E4\u05D9 \u05E2\u05DE\u05D5\u05D3\u05D4 ".concat(args.columnName, " \u05D1\u05E1\u05D3\u05E8 \u05D9\u05D5\u05E8\u05D3"),
  "resizerDescription": "\u05D4\u05E7\u05E9 Enter \u05DB\u05D3\u05D9 \u05DC\u05E9\u05E0\u05D5\u05EA \u05D0\u05EA \u05D4\u05D2\u05D5\u05D3\u05DC",
  "select": "\u05D1\u05D7\u05E8",
  "selectAll": "\u05D1\u05D7\u05E8 \u05D4\u05DB\u05D5\u05DC",
  "sortable": "\u05E2\u05DE\u05D5\u05D3\u05D4 \u05E9\u05E0\u05D9\u05EA\u05DF \u05DC\u05DE\u05D9\u05D9\u05DF"
};
var $c3d9f76f15300329$exports = {};
$c3d9f76f15300329$exports = {
  "ascending": "rastu\u0107i",
  "ascendingSort": args => "razvrstano po stupcima ".concat(args.columnName, " rastu\u0107em redoslijedom"),
  "columnSize": args => "".concat(args.value, " piksela"),
  "descending": "padaju\u0107i",
  "descendingSort": args => "razvrstano po stupcima ".concat(args.columnName, " padaju\u0107im redoslijedom"),
  "resizerDescription": "Pritisnite Enter da biste zapo\u010Deli promenu veli\u010Dine",
  "select": "Odaberite",
  "selectAll": "Odaberite sve",
  "sortable": "stupac koji se mo\u017Ee razvrstati"
};
var $9904561a995a328e$exports = {};
$9904561a995a328e$exports = {
  "ascending": "n\xF6vekv\u0151",
  "ascendingSort": args => "rendezve a(z) ".concat(args.columnName, " oszlop szerint, n\xF6vekv\u0151 sorrendben"),
  "columnSize": args => "".concat(args.value, " k\xE9ppont"),
  "descending": "cs\xF6kken\u0151",
  "descendingSort": args => "rendezve a(z) ".concat(args.columnName, " oszlop szerint, cs\xF6kken\u0151 sorrendben"),
  "resizerDescription": "Nyomja le az Enter billenty\u0171t az \xE1tm\xE9retez\xE9s megkezd\xE9s\xE9hez",
  "select": "Kijel\xF6l\xE9s",
  "selectAll": "\xD6sszes kijel\xF6l\xE9se",
  "sortable": "rendezend\u0151 oszlop"
};
var $b63a88a974650d19$exports = {};
$b63a88a974650d19$exports = {
  "ascending": "crescente",
  "ascendingSort": args => "in ordine crescente in base alla colonna ".concat(args.columnName),
  "columnSize": args => "".concat(args.value, " pixel"),
  "descending": "decrescente",
  "descendingSort": args => "in ordine decrescente in base alla colonna ".concat(args.columnName),
  "resizerDescription": "Premi Invio per iniziare a ridimensionare",
  "select": "Seleziona",
  "selectAll": "Seleziona tutto",
  "sortable": "colonna ordinabile"
};
var $f79114b6f7838962$exports = {};
$f79114b6f7838962$exports = {
  "ascending": "\u6607\u9806",
  "ascendingSort": args => "\u5217 ".concat(args.columnName, " \u3092\u6607\u9806\u3067\u4E26\u3079\u66FF\u3048"),
  "columnSize": args => "".concat(args.value, " \u30D4\u30AF\u30BB\u30EB"),
  "descending": "\u964D\u9806",
  "descendingSort": args => "\u5217 ".concat(args.columnName, " \u3092\u964D\u9806\u3067\u4E26\u3079\u66FF\u3048"),
  "resizerDescription": "Enter \u30AD\u30FC\u3092\u62BC\u3057\u3066\u30B5\u30A4\u30BA\u5909\u66F4\u3092\u958B\u59CB",
  "select": "\u9078\u629E",
  "selectAll": "\u3059\u3079\u3066\u9078\u629E",
  "sortable": "\u4E26\u3079\u66FF\u3048\u53EF\u80FD\u306A\u5217"
};
var $305e358db516b233$exports = {};
$305e358db516b233$exports = {
  "ascending": "\uC624\uB984\uCC28\uC21C",
  "ascendingSort": args => "".concat(args.columnName, " \uC5F4\uC744 \uAE30\uC900\uC73C\uB85C \uC624\uB984\uCC28\uC21C\uC73C\uB85C \uC815\uB82C\uB428"),
  "columnSize": args => "".concat(args.value, " \uD53D\uC140"),
  "descending": "\uB0B4\uB9BC\uCC28\uC21C",
  "descendingSort": args => "".concat(args.columnName, " \uC5F4\uC744 \uAE30\uC900\uC73C\uB85C \uB0B4\uB9BC\uCC28\uC21C\uC73C\uB85C \uC815\uB82C\uB428"),
  "resizerDescription": "\uD06C\uAE30 \uC870\uC815\uC744 \uC2DC\uC791\uD558\uB824\uBA74 Enter\uB97C \uB204\uB974\uC138\uC694.",
  "select": "\uC120\uD0DD",
  "selectAll": "\uBAA8\uB450 \uC120\uD0DD",
  "sortable": "\uC815\uB82C \uAC00\uB2A5\uD55C \uC5F4"
};
var $c37a95c245032ee0$exports = {};
$c37a95c245032ee0$exports = {
  "ascending": "did\u0117jan\u010Dia tvarka",
  "ascendingSort": args => "surikiuota pagal stulpel\u012F ".concat(args.columnName, " did\u0117jan\u010Dia tvarka"),
  "columnSize": args => "".concat(args.value, " piks."),
  "descending": "ma\u017E\u0117jan\u010Dia tvarka",
  "descendingSort": args => "surikiuota pagal stulpel\u012F ".concat(args.columnName, " ma\u017E\u0117jan\u010Dia tvarka"),
  "resizerDescription": "Paspauskite \u201EEnter\u201C, kad prad\u0117tum\u0117te keisti dyd\u012F",
  "select": "Pasirinkti",
  "selectAll": "Pasirinkti visk\u0105",
  "sortable": "rikiuojamas stulpelis"
};
var $0d99b6662f72a76d$exports = {};
$0d99b6662f72a76d$exports = {
  "ascending": "augo\u0161\u0101 sec\u012Bb\u0101",
  "ascendingSort": args => "k\u0101rtots p\u0113c kolonnas ".concat(args.columnName, " augo\u0161\u0101 sec\u012Bb\u0101"),
  "columnSize": args => "".concat(args.value, " pikse\u013Ci"),
  "descending": "dilsto\u0161\u0101 sec\u012Bb\u0101",
  "descendingSort": args => "k\u0101rtots p\u0113c kolonnas ".concat(args.columnName, " dilsto\u0161\u0101 sec\u012Bb\u0101"),
  "resizerDescription": "Nospiediet Enter, lai s\u0101ktu izm\u0113ru main\u012B\u0161anu",
  "select": "Atlas\u012Bt",
  "selectAll": "Atlas\u012Bt visu",
  "sortable": "k\u0101rtojam\u0101 kolonna"
};
var $b350dd154e1c203e$exports = {};
$b350dd154e1c203e$exports = {
  "ascending": "stigende",
  "ascendingSort": args => "sortert etter kolonne ".concat(args.columnName, " i stigende rekkef\xF8lge"),
  "columnSize": args => "".concat(args.value, " piksler"),
  "descending": "synkende",
  "descendingSort": args => "sortert etter kolonne ".concat(args.columnName, " i synkende rekkef\xF8lge"),
  "resizerDescription": "Trykk p\xE5 Enter for \xE5 starte st\xF8rrelsesendring",
  "select": "Velg",
  "selectAll": "Velg alle",
  "sortable": "kolonne som kan sorteres"
};
var $94dcc10598f2ecbe$exports = {};
$94dcc10598f2ecbe$exports = {
  "ascending": "oplopend",
  "ascendingSort": args => "gesorteerd in oplopende volgorde in kolom ".concat(args.columnName),
  "columnSize": args => "".concat(args.value, " pixels"),
  "descending": "aflopend",
  "descendingSort": args => "gesorteerd in aflopende volgorde in kolom ".concat(args.columnName),
  "resizerDescription": "Druk op Enter om het formaat te wijzigen",
  "select": "Selecteren",
  "selectAll": "Alles selecteren",
  "sortable": "sorteerbare kolom"
};
var $847263ec44d85feb$exports = {};
$847263ec44d85feb$exports = {
  "ascending": "rosn\u0105co",
  "ascendingSort": args => "posortowano wed\u0142ug kolumny ".concat(args.columnName, " w porz\u0105dku rosn\u0105cym"),
  "columnSize": args => "Liczba pikseli: ".concat(args.value),
  "descending": "malej\u0105co",
  "descendingSort": args => "posortowano wed\u0142ug kolumny ".concat(args.columnName, " w porz\u0105dku malej\u0105cym"),
  "resizerDescription": "Naci\u015Bnij Enter, aby rozpocz\u0105\u0107 zmienianie rozmiaru",
  "select": "Zaznacz",
  "selectAll": "Zaznacz wszystko",
  "sortable": "kolumna z mo\u017Cliwo\u015Bci\u0105 sortowania"
};
var $649f25af616381b6$exports = {};
$649f25af616381b6$exports = {
  "ascending": "crescente",
  "ascendingSort": args => "classificado pela coluna ".concat(args.columnName, " em ordem crescente"),
  "columnSize": args => "".concat(args.value, " pixels"),
  "descending": "decrescente",
  "descendingSort": args => "classificado pela coluna ".concat(args.columnName, " em ordem decrescente"),
  "resizerDescription": "Pressione Enter para come\xE7ar a redimensionar",
  "select": "Selecionar",
  "selectAll": "Selecionar tudo",
  "sortable": "coluna classific\xE1vel"
};
var $63863f752f22090b$exports = {};
$63863f752f22090b$exports = {
  "ascending": "ascendente",
  "ascendingSort": args => "Ordenar por coluna ".concat(args.columnName, " em ordem ascendente"),
  "columnSize": args => "".concat(args.value, " pixels"),
  "descending": "descendente",
  "descendingSort": args => "Ordenar por coluna ".concat(args.columnName, " em ordem descendente"),
  "resizerDescription": "Prima Enter para iniciar o redimensionamento",
  "select": "Selecionar",
  "selectAll": "Selecionar tudo",
  "sortable": "Coluna orden\xE1vel"
};
var $1011caef6838d0cf$exports = {};
$1011caef6838d0cf$exports = {
  "ascending": "cresc\u0103toare",
  "ascendingSort": args => "sortate dup\u0103 coloana ".concat(args.columnName, " \xEEn ordine cresc\u0103toare"),
  "columnSize": args => "".concat(args.value, " pixeli"),
  "descending": "descresc\u0103toare",
  "descendingSort": args => "sortate dup\u0103 coloana ".concat(args.columnName, " \xEEn ordine descresc\u0103toare"),
  "resizerDescription": "Ap\u0103sa\u021Bi pe Enter pentru a \xEEncepe redimensionarea",
  "select": "Selectare",
  "selectAll": "Selectare total\u0103",
  "sortable": "coloan\u0103 sortabil\u0103"
};
var $5c0e71883f016b2f$exports = {};
$5c0e71883f016b2f$exports = {
  "ascending": "\u0432\u043E\u0437\u0440\u0430\u0441\u0442\u0430\u043D\u0438\u0435",
  "ascendingSort": args => "\u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0441\u0442\u043E\u043B\u0431\u0435\u0446 ".concat(args.columnName, " \u0432 \u043F\u043E\u0440\u044F\u0434\u043A\u0435 \u0432\u043E\u0437\u0440\u0430\u0441\u0442\u0430\u043D\u0438\u044F"),
  "columnSize": args => "".concat(args.value, " \u043F\u0438\u043A\u0441."),
  "descending": "\u0443\u0431\u044B\u0432\u0430\u043D\u0438\u0435",
  "descendingSort": args => "\u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0441\u0442\u043E\u043B\u0431\u0435\u0446 ".concat(args.columnName, " \u0432 \u043F\u043E\u0440\u044F\u0434\u043A\u0435 \u0443\u0431\u044B\u0432\u0430\u043D\u0438\u044F"),
  "resizerDescription": "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043A\u043B\u0430\u0432\u0438\u0448\u0443 Enter \u0434\u043B\u044F \u043D\u0430\u0447\u0430\u043B\u0430 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0440\u0430\u0437\u043C\u0435\u0440\u043E\u0432",
  "select": "\u0412\u044B\u0431\u0440\u0430\u0442\u044C",
  "selectAll": "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0432\u0441\u0435",
  "sortable": "\u0441\u043E\u0440\u0442\u0438\u0440\u0443\u0435\u043C\u044B\u0439 \u0441\u0442\u043E\u043B\u0431\u0435\u0446"
};
var $9799788df99a536e$exports = {};
$9799788df99a536e$exports = {
  "ascending": "vzostupne",
  "ascendingSort": args => "zoraden\xE9 zostupne pod\u013Ea st\u013Apca ".concat(args.columnName),
  "columnSize": args => "Po\u010Det pixelov: ".concat(args.value),
  "descending": "zostupne",
  "descendingSort": args => "zoraden\xE9 zostupne pod\u013Ea st\u013Apca ".concat(args.columnName),
  "resizerDescription": "Stla\u010Den\xEDm kl\xE1vesu Enter za\u010Dnete zmenu ve\u013Ekosti",
  "select": "Vybra\u0165",
  "selectAll": "Vybra\u0165 v\u0161etko",
  "sortable": "zoradite\u013En\xFD st\u013Apec"
};
var $79bf9bea0e0b8579$exports = {};
$79bf9bea0e0b8579$exports = {
  "ascending": "nara\u0161\u010Dajo\u010De",
  "ascendingSort": args => "razvr\u0161\u010Deno po stolpcu ".concat(args.columnName, " v nara\u0161\u010Dajo\u010Dem vrstnem redu"),
  "columnSize": args => "".concat(args.value, " slikovnih pik"),
  "descending": "padajo\u010De",
  "descendingSort": args => "razvr\u0161\u010Deno po stolpcu ".concat(args.columnName, " v padajo\u010Dem vrstnem redu"),
  "resizerDescription": "Pritisnite tipko Enter da za\u010Dnete spreminjati velikost",
  "select": "Izberite",
  "selectAll": "Izberite vse",
  "sortable": "razvrstljivi stolpec"
};
var $374736afc1a4c11c$exports = {};
$374736afc1a4c11c$exports = {
  "ascending": "rastu\u0107i",
  "ascendingSort": args => "sortirano po kolonama ".concat(args.columnName, " padaju\u0107im redosledom"),
  "columnSize": args => "".concat(args.value, " piksela"),
  "descending": "padaju\u0107i",
  "descendingSort": args => "sortirano po kolonama ".concat(args.columnName, " padaju\u0107im redosledom"),
  "resizerDescription": "Pritisnite Enter da biste zapo\u010Deli promenu veli\u010Dine",
  "select": "Izaberite",
  "selectAll": "Izaberite sve",
  "sortable": "kolona koja se mo\u017Ee sortirati"
};
var $948317bce9061901$exports = {};
$948317bce9061901$exports = {
  "ascending": "stigande",
  "ascendingSort": args => "sorterat p\xE5 kolumn ".concat(args.columnName, " i stigande ordning"),
  "columnSize": args => "".concat(args.value, " pixlar"),
  "descending": "fallande",
  "descendingSort": args => "sorterat p\xE5 kolumn ".concat(args.columnName, " i fallande ordning"),
  "resizerDescription": "Tryck p\xE5 Retur f\xF6r att b\xF6rja \xE4ndra storlek",
  "select": "Markera",
  "selectAll": "Markera allt",
  "sortable": "sorterbar kolumn"
};
var $73e2289d5a9ac4de$exports = {};
$73e2289d5a9ac4de$exports = {
  "ascending": "artan s\u0131rada",
  "ascendingSort": args => "".concat(args.columnName, " s\xFCtuna g\xF6re artan d\xFCzende s\u0131rala"),
  "columnSize": args => "".concat(args.value, " piksel"),
  "descending": "azalan s\u0131rada",
  "descendingSort": args => "".concat(args.columnName, " s\xFCtuna g\xF6re azalan d\xFCzende s\u0131rala"),
  "resizerDescription": "Yeniden boyutland\u0131rmak i\xE7in Enter'a bas\u0131n",
  "select": "Se\xE7",
  "selectAll": "T\xFCm\xFCn\xFC Se\xE7",
  "sortable": "S\u0131ralanabilir s\xFCtun"
};
var $aca57efccc60ebb1$exports = {};
$aca57efccc60ebb1$exports = {
  "ascending": "\u0432\u0438\u0441\u0445\u0456\u0434\u043D\u0438\u0439",
  "ascendingSort": args => "\u0432\u0456\u0434\u0441\u043E\u0440\u0442\u043E\u0432\u0430\u043D\u043E \u0437\u0430 \u0441\u0442\u043E\u0432\u043F\u0446\u0435\u043C ".concat(args.columnName, " \u0443 \u0432\u0438\u0441\u0445\u0456\u0434\u043D\u043E\u043C\u0443 \u043F\u043E\u0440\u044F\u0434\u043A\u0443"),
  "columnSize": args => "".concat(args.value, " \u043F\u0456\u043A\u0441."),
  "descending": "\u043D\u0438\u0437\u0445\u0456\u0434\u043D\u0438\u0439",
  "descendingSort": args => "\u0432\u0456\u0434\u0441\u043E\u0440\u0442\u043E\u0432\u0430\u043D\u043E \u0437\u0430 \u0441\u0442\u043E\u0432\u043F\u0446\u0435\u043C ".concat(args.columnName, " \u0443 \u043D\u0438\u0437\u0445\u0456\u0434\u043D\u043E\u043C\u0443 \u043F\u043E\u0440\u044F\u0434\u043A\u0443"),
  "resizerDescription": "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C Enter, \u0449\u043E\u0431 \u043F\u043E\u0447\u0430\u0442\u0438 \u0437\u043C\u0456\u043D\u0443 \u0440\u043E\u0437\u043C\u0456\u0440\u0443",
  "select": "\u0412\u0438\u0431\u0440\u0430\u0442\u0438",
  "selectAll": "\u0412\u0438\u0431\u0440\u0430\u0442\u0438 \u0432\u0441\u0435",
  "sortable": "\u0441\u043E\u0440\u0442\u0443\u0432\u0430\u043B\u044C\u043D\u0438\u0439 \u0441\u0442\u043E\u0432\u043F\u0435\u0446\u044C"
};
var $ccd86abad329f871$exports = {};
$ccd86abad329f871$exports = {
  "ascending": "\u5347\u5E8F",
  "ascendingSort": args => "\u6309\u5217 ".concat(args.columnName, " \u5347\u5E8F\u6392\u5E8F"),
  "columnSize": args => "".concat(args.value, " \u50CF\u7D20"),
  "descending": "\u964D\u5E8F",
  "descendingSort": args => "\u6309\u5217 ".concat(args.columnName, " \u964D\u5E8F\u6392\u5E8F"),
  "resizerDescription": "\u6309\u201C\u8F93\u5165\u201D\u952E\u5F00\u59CB\u8C03\u6574\u5927\u5C0F\u3002",
  "select": "\u9009\u62E9",
  "selectAll": "\u5168\u9009",
  "sortable": "\u53EF\u6392\u5E8F\u7684\u5217"
};
var $ad6eb5efb83fe2f8$exports = {};
$ad6eb5efb83fe2f8$exports = {
  "ascending": "\u905E\u589E",
  "ascendingSort": args => "\u5DF2\u4F9D\u64DA\u300C".concat(args.columnName, "\u300D\u6B04\u905E\u589E\u6392\u5E8F"),
  "columnSize": args => "".concat(args.value, " \u50CF\u7D20"),
  "descending": "\u905E\u6E1B",
  "descendingSort": args => "\u5DF2\u4F9D\u64DA\u300C".concat(args.columnName, "\u300D\u6B04\u905E\u6E1B\u6392\u5E8F"),
  "resizerDescription": "\u6309 Enter \u9375\u4EE5\u958B\u59CB\u8ABF\u6574\u5927\u5C0F",
  "select": "\u9078\u53D6",
  "selectAll": "\u5168\u9078",
  "sortable": "\u53EF\u6392\u5E8F\u7684\u6B04"
};
$7ff3f66df3873a5e$exports = {
  "ar-AE": $ca0f93ae476efcee$exports,
  "bg-BG": $8fcf86b24fd399a9$exports,
  "cs-CZ": $146712099a722811$exports,
  "da-DK": $2735c96991aebe53$exports,
  "de-DE": $d85ed0c826146b1e$exports,
  "el-GR": $1aecf8df24cd2c6e$exports,
  "en-US": $8629e38d73986227$exports,
  "es-ES": $219ef73190fd7b54$exports,
  "et-EE": $28e4d12b64c559fe$exports,
  "fi-FI": $d443cdd0bb14863a$exports,
  "fr-FR": $e7b61bd0e93b97c5$exports,
  "he-IL": $b09d12ffa0a56a3e$exports,
  "hr-HR": $c3d9f76f15300329$exports,
  "hu-HU": $9904561a995a328e$exports,
  "it-IT": $b63a88a974650d19$exports,
  "ja-JP": $f79114b6f7838962$exports,
  "ko-KR": $305e358db516b233$exports,
  "lt-LT": $c37a95c245032ee0$exports,
  "lv-LV": $0d99b6662f72a76d$exports,
  "nb-NO": $b350dd154e1c203e$exports,
  "nl-NL": $94dcc10598f2ecbe$exports,
  "pl-PL": $847263ec44d85feb$exports,
  "pt-BR": $649f25af616381b6$exports,
  "pt-PT": $63863f752f22090b$exports,
  "ro-RO": $1011caef6838d0cf$exports,
  "ru-RU": $5c0e71883f016b2f$exports,
  "sk-SK": $9799788df99a536e$exports,
  "sl-SI": $79bf9bea0e0b8579$exports,
  "sr-SP": $374736afc1a4c11c$exports,
  "sv-SE": $948317bce9061901$exports,
  "tr-TR": $73e2289d5a9ac4de$exports,
  "uk-UA": $aca57efccc60ebb1$exports,
  "zh-CN": $ccd86abad329f871$exports,
  "zh-TW": $ad6eb5efb83fe2f8$exports
};

/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

class $a911ff492b884835$export$da43f8f5cb04028d extends (0, $kJQf8$reactariagrid.GridKeyboardDelegate) {
  isCell(node) {
    return node.type === "cell" || node.type === "rowheader" || node.type === "column";
  }
  getKeyBelow(key) {
    let startItem = this.collection.getItem(key);
    if (!startItem) return;
    // If focus was on a column, then focus the first child column if any,
    // or find the corresponding cell in the first row.
    if (startItem.type === "column") {
      let child = (0, $kJQf8$reactstatelycollections.getFirstItem)((0, $kJQf8$reactstatelycollections.getChildNodes)(startItem, this.collection));
      if (child) return child.key;
      let firstKey = this.getFirstKey();
      if (firstKey == null) return;
      let firstItem = this.collection.getItem(firstKey);
      return (0, $kJQf8$reactstatelycollections.getNthItem)((0, $kJQf8$reactstatelycollections.getChildNodes)(firstItem, this.collection), startItem.index).key;
    }
    return super.getKeyBelow(key);
  }
  getKeyAbove(key) {
    let startItem = this.collection.getItem(key);
    if (!startItem) return;
    // If focus was on a column, focus the parent column if any
    if (startItem.type === "column") {
      let parent = this.collection.getItem(startItem.parentKey);
      if (parent && parent.type === "column") return parent.key;
      return;
    }
    // only return above row key if not header row
    let superKey = super.getKeyAbove(key);
    if (superKey != null && this.collection.getItem(superKey).type !== "headerrow") return superKey;
    // If no item was found, and focus was on a cell, then focus the
    // corresponding column header.
    if (this.isCell(startItem)) return this.collection.columns[startItem.index].key;
    // If focus was on a row, then focus the first column header.
    return this.collection.columns[0].key;
  }
  findNextColumnKey(column) {
    // Search following columns
    let key = this.findNextKey(column.key, item => item.type === "column");
    if (key != null) return key;
    // Wrap around to the first column
    let row = this.collection.headerRows[column.level];
    for (let item of (0, $kJQf8$reactstatelycollections.getChildNodes)(row, this.collection)) {
      if (item.type === "column") return item.key;
    }
  }
  findPreviousColumnKey(column) {
    // Search previous columns
    let key = this.findPreviousKey(column.key, item => item.type === "column");
    if (key != null) return key;
    // Wrap around to the last column
    let row = this.collection.headerRows[column.level];
    let childNodes = [...(0, $kJQf8$reactstatelycollections.getChildNodes)(row, this.collection)];
    for (let i = childNodes.length - 1; i >= 0; i--) {
      let item = childNodes[i];
      if (item.type === "column") return item.key;
    }
  }
  getKeyRightOf(key) {
    let item = this.collection.getItem(key);
    if (!item) return;
    // If focus was on a column, then focus the next column
    if (item.type === "column") return this.direction === "rtl" ? this.findPreviousColumnKey(item) : this.findNextColumnKey(item);
    return super.getKeyRightOf(key);
  }
  getKeyLeftOf(key) {
    let item = this.collection.getItem(key);
    if (!item) return;
    // If focus was on a column, then focus the previous column
    if (item.type === "column") return this.direction === "rtl" ? this.findNextColumnKey(item) : this.findPreviousColumnKey(item);
    return super.getKeyLeftOf(key);
  }
  getKeyForSearch(search, fromKey) {
    if (!this.collator) return null;
    let collection = this.collection;
    let key = fromKey !== null && fromKey !== void 0 ? fromKey : this.getFirstKey();
    if (key == null) return null;
    // If the starting key is a cell, search from its parent row.
    let startItem = collection.getItem(key);
    if (startItem.type === "cell") key = startItem.parentKey;
    let hasWrapped = false;
    while (key != null) {
      let item = collection.getItem(key);
      // Check each of the row header cells in this row for a match
      for (let cell of (0, $kJQf8$reactstatelycollections.getChildNodes)(item, this.collection)) {
        let column = collection.columns[cell.index];
        if (collection.rowHeaderColumnKeys.has(column.key) && cell.textValue) {
          let substring = cell.textValue.slice(0, search.length);
          if (this.collator.compare(substring, search) === 0) {
            // If we started on a cell, end on the matching cell. Otherwise, end on the row.
            let fromItem = fromKey != null ? collection.getItem(fromKey) : startItem;
            return fromItem.type === "cell" ? cell.key : item.key;
          }
        }
      }
      key = this.getKeyBelow(key);
      // Wrap around when reaching the end of the collection
      if (key == null && !hasWrapped) {
        key = this.getFirstKey();
        hasWrapped = true;
      }
    }
    return null;
  }
}
function $25d14c0f8fad722e$export$25bceaac3c7e4dc7(props, state, ref) {
  let {
    keyboardDelegate: keyboardDelegate,
    isVirtualized: isVirtualized,
    layout: layout
  } = props;
  // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
  // When virtualized, the layout object will be passed in as a prop and override this.
  let collator = (0, $kJQf8$reactariai18n.useCollator)({
    usage: "search",
    sensitivity: "base"
  });
  let {
    direction: direction
  } = (0, $kJQf8$reactariai18n.useLocale)();
  let disabledBehavior = state.selectionManager.disabledBehavior;
  let delegate = (0, $kJQf8$react.useMemo)(() => keyboardDelegate || new (0, $a911ff492b884835$export$da43f8f5cb04028d)({
    collection: state.collection,
    disabledKeys: disabledBehavior === "selection" ? new Set() : state.disabledKeys,
    ref: ref,
    direction: direction,
    collator: collator,
    layout: layout
  }), [keyboardDelegate, state.collection, state.disabledKeys, disabledBehavior, ref, direction, collator, layout]);
  let id = (0, $kJQf8$reactariautils.useId)(props.id);
  (0, $6acf696f746f932c$export$552312adfd451dab).set(state, id);
  let {
    gridProps: gridProps
  } = (0, $kJQf8$reactariagrid.useGrid)({
    ...props,
    id: id,
    keyboardDelegate: delegate
  }, state, ref);
  // Override to include header rows
  if (isVirtualized) gridProps["aria-rowcount"] = state.collection.size + state.collection.headerRows.length;
  if ((0, $kJQf8$reactstatelyflags.tableNestedRows)() && "expandedKeys" in state) gridProps.role = "treegrid";
  let {
    column: column,
    direction: sortDirection
  } = state.sortDescriptor || {};
  let stringFormatter = (0, $kJQf8$reactariai18n.useLocalizedStringFormatter)((0, /*@__PURE__*/$parcel$interopDefault($7ff3f66df3873a5e$exports)));
  let sortDescription = (0, $kJQf8$react.useMemo)(() => {
    var _state_collection_columns_find;
    let columnName = (_state_collection_columns_find = state.collection.columns.find(c => c.key === column)) === null || _state_collection_columns_find === void 0 ? void 0 : _state_collection_columns_find.textValue;
    return sortDirection && column ? stringFormatter.format("".concat(sortDirection, "Sort"), {
      columnName: columnName
    }) : undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortDirection, column, state.collection.columns]);
  let descriptionProps = (0, $kJQf8$reactariautils.useDescription)(sortDescription);
  // Only announce after initial render, tabbing to the table will tell you the initial sort info already
  (0, $kJQf8$reactariautils.useUpdateEffect)(() => {
    (0, $kJQf8$reactarialiveannouncer.announce)(sortDescription, "assertive", 500);
  }, [sortDescription]);
  return {
    gridProps: (0, $kJQf8$reactariautils.mergeProps)(gridProps, descriptionProps, {
      // merge sort description with long press information
      "aria-describedby": [descriptionProps["aria-describedby"], gridProps["aria-describedby"]].filter(Boolean).join(" ")
    })
  };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $7669c34a63ef0113$export$9514819a8c81e960(props, state, ref) {
  var _state_sortDescriptor, _state_sortDescriptor1;
  let {
    node: node
  } = props;
  let allowsSorting = node.props.allowsSorting;
  // if there are no focusable children, the column header will focus the cell
  let {
    gridCellProps: gridCellProps
  } = (0, $kJQf8$reactariagrid.useGridCell)({
    ...props,
    focusMode: "child"
  }, state, ref);
  let isSelectionCellDisabled = node.props.isSelectionCell && state.selectionManager.selectionMode === "single";
  let {
    pressProps: pressProps
  } = (0, $kJQf8$reactariainteractions.usePress)({
    isDisabled: !allowsSorting || isSelectionCellDisabled,
    onPress() {
      state.sort(node.key);
    },
    ref: ref
  });
  // Needed to pick up the focusable context, enabling things like Tooltips for example
  let {
    focusableProps: focusableProps
  } = (0, $kJQf8$reactariafocus.useFocusable)({}, ref);
  let ariaSort = null;
  let isSortedColumn = ((_state_sortDescriptor = state.sortDescriptor) === null || _state_sortDescriptor === void 0 ? void 0 : _state_sortDescriptor.column) === node.key;
  let sortDirection = (_state_sortDescriptor1 = state.sortDescriptor) === null || _state_sortDescriptor1 === void 0 ? void 0 : _state_sortDescriptor1.direction;
  // aria-sort not supported in Android Talkback
  if (node.props.allowsSorting && !(0, $kJQf8$reactariautils.isAndroid)()) ariaSort = isSortedColumn ? sortDirection : "none";
  let stringFormatter = (0, $kJQf8$reactariai18n.useLocalizedStringFormatter)((0, /*@__PURE__*/$parcel$interopDefault($7ff3f66df3873a5e$exports)));
  let sortDescription;
  if (allowsSorting) {
    sortDescription = "".concat(stringFormatter.format("sortable"));
    // Android Talkback doesn't support aria-sort so we add sort order details to the aria-described by here
    if (isSortedColumn && sortDirection && (0, $kJQf8$reactariautils.isAndroid)()) sortDescription = "".concat(sortDescription, ", ").concat(stringFormatter.format(sortDirection));
  }
  let descriptionProps = (0, $kJQf8$reactariautils.useDescription)(sortDescription);
  let shouldDisableFocus = state.collection.size === 0;
  (0, $kJQf8$react.useEffect)(() => {
    if (shouldDisableFocus && state.selectionManager.focusedKey === node.key) state.selectionManager.setFocusedKey(null);
  }, [shouldDisableFocus, state.selectionManager, node.key]);
  return {
    columnHeaderProps: {
      ...(0, $kJQf8$reactariautils.mergeProps)(gridCellProps, pressProps, focusableProps, descriptionProps,
      // If the table is empty, make all column headers untabbable
      shouldDisableFocus && {
        tabIndex: -1
      }),
      role: "columnheader",
      id: (0, $6acf696f746f932c$export$37cd4213f2ad742e)(state, node.key),
      "aria-colspan": node.colspan && node.colspan > 1 ? node.colspan : null,
      "aria-sort": ariaSort
    }
  };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

const $10b2115217af7c93$var$EXPANSION_KEYS = {
  expand: {
    ltr: "ArrowRight",
    rtl: "ArrowLeft"
  },
  "collapse": {
    ltr: "ArrowLeft",
    rtl: "ArrowRight"
  }
};
function $10b2115217af7c93$export$7f2f6ae19e707aa5(props, state, ref) {
  let {
    node: node,
    isVirtualized: isVirtualized
  } = props;
  let {
    rowProps: rowProps,
    ...states
  } = (0, $kJQf8$reactariagrid.useGridRow)(props, state, ref);
  let {
    direction: direction
  } = (0, $kJQf8$reactariai18n.useLocale)();
  if (isVirtualized && !((0, $kJQf8$reactstatelyflags.tableNestedRows)() && "expandedKeys" in state)) rowProps["aria-rowindex"] = node.index + 1 + state.collection.headerRows.length; // aria-rowindex is 1 based
  else delete rowProps["aria-rowindex"];
  let treeGridRowProps = {};
  if ((0, $kJQf8$reactstatelyflags.tableNestedRows)() && "expandedKeys" in state) {
    let treeNode = state.keyMap.get(node.key);
    if (treeNode != null) {
      var _treeNode_props, _treeNode_props1, _treeNode_props_children;
      let hasChildRows = ((_treeNode_props = treeNode.props) === null || _treeNode_props === void 0 ? void 0 : _treeNode_props.UNSTABLE_childItems) || ((_treeNode_props1 = treeNode.props) === null || _treeNode_props1 === void 0 ? void 0 : (_treeNode_props_children = _treeNode_props1.children) === null || _treeNode_props_children === void 0 ? void 0 : _treeNode_props_children.length) > state.userColumnCount;
      treeGridRowProps = {
        onKeyDown: e => {
          if (e.key === $10b2115217af7c93$var$EXPANSION_KEYS["expand"][direction] && state.selectionManager.focusedKey === treeNode.key && hasChildRows && state.expandedKeys !== "all" && !state.expandedKeys.has(treeNode.key)) {
            state.toggleKey(treeNode.key);
            e.stopPropagation();
          } else if (e.key === $10b2115217af7c93$var$EXPANSION_KEYS["collapse"][direction] && state.selectionManager.focusedKey === treeNode.key && hasChildRows && (state.expandedKeys === "all" || state.expandedKeys.has(treeNode.key))) {
            state.toggleKey(treeNode.key);
            e.stopPropagation();
          }
        },
        "aria-expanded": hasChildRows ? state.expandedKeys === "all" || state.expandedKeys.has(node.key) : undefined,
        "aria-level": treeNode.level,
        "aria-posinset": treeNode.indexOfType + 1,
        "aria-setsize": treeNode.level > 1 ? (0, $kJQf8$reactstatelycollections.getLastItem)(state.keyMap.get(treeNode === null || treeNode === void 0 ? void 0 : treeNode.parentKey).childNodes).indexOfType + 1 : (0, $kJQf8$reactstatelycollections.getLastItem)(state.keyMap.get(state.collection.body.key).childNodes).indexOfType + 1
      };
    }
  }
  return {
    rowProps: {
      ...(0, $kJQf8$reactariautils.mergeProps)(rowProps, treeGridRowProps),
      "aria-labelledby": (0, $6acf696f746f932c$export$85069b70317f543)(state, node.key)
    },
    ...states
  };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
function $eb16c38321a72835$export$1b95a7d2d517b841(props, state, ref) {
  let {
    node: node,
    isVirtualized: isVirtualized
  } = props;
  let rowProps = {
    role: "row"
  };
  if (isVirtualized && !((0, $kJQf8$reactstatelyflags.tableNestedRows)() && "expandedKeys" in state)) rowProps["aria-rowindex"] = node.index + 1; // aria-rowindex is 1 based
  return {
    rowProps: rowProps
  };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $32387a1f2c61cda2$export$49571c903d73624c(props, state, ref) {
  let {
    gridCellProps: gridCellProps,
    isPressed: isPressed
  } = (0, $kJQf8$reactariagrid.useGridCell)(props, state, ref);
  let columnKey = props.node.column.key;
  if (state.collection.rowHeaderColumnKeys.has(columnKey)) {
    gridCellProps.role = "rowheader";
    gridCellProps.id = (0, $6acf696f746f932c$export$19baff3266315d44)(state, props.node.parentKey, columnKey);
  }
  return {
    gridCellProps: gridCellProps,
    isPressed: isPressed
  };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $0b394e4562ac57c9$export$16ea7f650bd7c1bb(props, state) {
  let {
    key: key
  } = props;
  const {
    checkboxProps: checkboxProps
  } = (0, $kJQf8$reactariagrid.useGridSelectionCheckbox)(props, state);
  return {
    checkboxProps: {
      ...checkboxProps,
      "aria-labelledby": "".concat(checkboxProps.id, " ").concat((0, $6acf696f746f932c$export$85069b70317f543)(state, key))
    }
  };
}
function $0b394e4562ac57c9$export$1003db6a7e384b99(state) {
  let {
    isEmpty: isEmpty,
    isSelectAll: isSelectAll,
    selectionMode: selectionMode
  } = state.selectionManager;
  const stringFormatter = (0, $kJQf8$reactariai18n.useLocalizedStringFormatter)((0, /*@__PURE__*/$parcel$interopDefault($7ff3f66df3873a5e$exports)));
  return {
    checkboxProps: {
      "aria-label": stringFormatter.format(selectionMode === "single" ? "select" : "selectAll"),
      isSelected: isSelectAll,
      isDisabled: selectionMode !== "multiple" || state.collection.size === 0,
      isIndeterminate: !isEmpty && !isSelectAll,
      onChange: () => state.selectionManager.toggleSelectAll()
    }
  };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $16d645f9e2153641$export$52994e973806c219(props, state, ref) {
  let {
    column: item,
    triggerRef: triggerRef,
    isDisabled: isDisabled,
    onResizeStart: onResizeStart,
    onResize: onResize,
    onResizeEnd: onResizeEnd,
    "aria-label": ariaLabel
  } = props;
  const stringFormatter = (0, $kJQf8$reactariai18n.useLocalizedStringFormatter)((0, /*@__PURE__*/$parcel$interopDefault($7ff3f66df3873a5e$exports)));
  let id = (0, $kJQf8$reactariautils.useId)();
  let isResizing = state.resizingColumn === item.key;
  let isResizingRef = (0, $kJQf8$react.useRef)(isResizing);
  let lastSize = (0, $kJQf8$react.useRef)(null);
  let wasFocusedOnResizeStart = (0, $kJQf8$react.useRef)(false);
  let editModeEnabled = state.tableState.isKeyboardNavigationDisabled;
  let {
    direction: direction
  } = (0, $kJQf8$reactariai18n.useLocale)();
  let {
    keyboardProps: keyboardProps
  } = (0, $kJQf8$reactariainteractions.useKeyboard)({
    onKeyDown: e => {
      if (editModeEnabled) {
        if (e.key === "Escape" || e.key === "Enter" || e.key === " " || e.key === "Tab") {
          e.preventDefault();
          endResize(item);
        }
      } else {
        // Continue propagation on keydown events so they still bubbles to useSelectableCollection and are handled there
        e.continuePropagation();
        if (e.key === "Enter") startResize(item);
      }
    }
  });
  let startResize = (0, $kJQf8$reactariautils.useEffectEvent)(item => {
    if (!isResizingRef.current) {
      lastSize.current = state.updateResizedColumns(item.key, state.getColumnWidth(item.key));
      state.startResize(item.key);
      state.tableState.setKeyboardNavigationDisabled(true);
      onResizeStart === null || onResizeStart === void 0 ? void 0 : onResizeStart(lastSize.current);
    }
    isResizingRef.current = true;
  });
  let resize = (0, $kJQf8$reactariautils.useEffectEvent)((item, newWidth) => {
    let sizes = state.updateResizedColumns(item.key, newWidth);
    onResize === null || onResize === void 0 ? void 0 : onResize(sizes);
    lastSize.current = sizes;
  });
  let endResize = (0, $kJQf8$reactariautils.useEffectEvent)(item => {
    if (isResizingRef.current) {
      if (lastSize.current == null) lastSize.current = state.updateResizedColumns(item.key, state.getColumnWidth(item.key));
      state.endResize();
      state.tableState.setKeyboardNavigationDisabled(false);
      onResizeEnd === null || onResizeEnd === void 0 ? void 0 : onResizeEnd(lastSize.current);
      isResizingRef.current = false;
      if ((triggerRef === null || triggerRef === void 0 ? void 0 : triggerRef.current) && !wasFocusedOnResizeStart.current)
        // switch focus back to the column header unless the resizer was already focused when resizing started.
        (0, $kJQf8$reactariafocus.focusSafely)(triggerRef.current);
    }
    lastSize.current = null;
  });
  const columnResizeWidthRef = (0, $kJQf8$react.useRef)(0);
  const {
    moveProps: moveProps
  } = (0, $kJQf8$reactariainteractions.useMove)({
    onMoveStart() {
      columnResizeWidthRef.current = state.getColumnWidth(item.key);
      startResize(item);
    },
    onMove(e) {
      let {
        deltaX: deltaX,
        deltaY: deltaY,
        pointerType: pointerType
      } = e;
      if (direction === "rtl") deltaX *= -1;
      if (pointerType === "keyboard") {
        if (deltaY !== 0 && deltaX === 0) deltaX = deltaY * -1;
        deltaX *= 10;
      }
      // if moving up/down only, no need to resize
      if (deltaX !== 0) {
        columnResizeWidthRef.current += deltaX;
        resize(item, columnResizeWidthRef.current);
      }
    },
    onMoveEnd(e) {
      let {
        pointerType: pointerType
      } = e;
      columnResizeWidthRef.current = 0;
      if (pointerType === "mouse" || pointerType === "touch" && wasFocusedOnResizeStart.current) endResize(item);
    }
  });
  let onKeyDown = (0, $kJQf8$react.useCallback)(e => {
    if (editModeEnabled) moveProps.onKeyDown(e);
  }, [editModeEnabled, moveProps]);
  let min = Math.floor(state.getColumnMinWidth(item.key));
  let max = Math.floor(state.getColumnMaxWidth(item.key));
  if (max === Infinity) max = Number.MAX_SAFE_INTEGER;
  let value = Math.floor(state.getColumnWidth(item.key));
  let modality = (0, $kJQf8$reactariainteractions.useInteractionModality)();
  if (modality === "virtual" && typeof window !== "undefined" && "ontouchstart" in window) modality = "touch";
  let description = (triggerRef === null || triggerRef === void 0 ? void 0 : triggerRef.current) == null && (modality === "keyboard" || modality === "virtual") && !isResizing ? stringFormatter.format("resizerDescription") : undefined;
  let descriptionProps = (0, $kJQf8$reactariautils.useDescription)(description);
  let ariaProps = {
    "aria-label": ariaLabel,
    "aria-orientation": "horizontal",
    "aria-labelledby": "".concat(id, " ").concat((0, $6acf696f746f932c$export$37cd4213f2ad742e)(state.tableState, item.key)),
    "aria-valuetext": stringFormatter.format("columnSize", {
      value: value
    }),
    "type": "range",
    min: min,
    max: max,
    value: value,
    ...descriptionProps
  };
  const focusInput = (0, $kJQf8$react.useCallback)(() => {
    if (ref.current) (0, $kJQf8$reactariafocus.focusSafely)(ref.current);
  }, [ref]);
  let resizingColumn = state.resizingColumn;
  let prevResizingColumn = (0, $kJQf8$react.useRef)(null);
  (0, $kJQf8$react.useEffect)(() => {
    if (prevResizingColumn.current !== resizingColumn && resizingColumn != null && resizingColumn === item.key) {
      wasFocusedOnResizeStart.current = document.activeElement === ref.current;
      startResize(item);
      // Delay focusing input until Android Chrome's delayed click after touchend happens: https://bugs.chromium.org/p/chromium/issues/detail?id=1150073
      let timeout = setTimeout(() => focusInput(), 0);
      // VoiceOver on iOS has problems focusing the input from a menu.
      let VOTimeout = setTimeout(focusInput, 400);
      return () => {
        clearTimeout(timeout);
        clearTimeout(VOTimeout);
      };
    }
    prevResizingColumn.current = resizingColumn;
  }, [resizingColumn, item, focusInput, ref, startResize]);
  let onChange = e => {
    let currentWidth = state.getColumnWidth(item.key);
    let nextValue = parseFloat(e.target.value);
    if (nextValue > currentWidth) nextValue = currentWidth + 10;else nextValue = currentWidth - 10;
    resize(item, nextValue);
  };
  let {
    pressProps: pressProps
  } = (0, $kJQf8$reactariainteractions.usePress)({
    onPressStart: e => {
      if (e.ctrlKey || e.altKey || e.metaKey || e.shiftKey || e.pointerType === "keyboard") return;
      if (e.pointerType === "virtual" && state.resizingColumn != null) {
        endResize(item);
        return;
      }
      // Sometimes onPress won't trigger for quick taps on mobile so we want to focus the input so blurring away
      // can cancel resize mode for us.
      focusInput();
      // If resizer is always visible, mobile screenreader user can access the visually hidden resizer directly and thus we don't need
      // to handle a virtual click to start the resizer.
      if (e.pointerType !== "virtual") startResize(item);
    },
    onPress: e => {
      if ((e.pointerType === "touch" && wasFocusedOnResizeStart.current || e.pointerType === "mouse") && state.resizingColumn != null) endResize(item);
    }
  });
  let {
    visuallyHiddenProps: visuallyHiddenProps
  } = (0, $kJQf8$reactariavisuallyhidden.useVisuallyHidden)();
  return {
    resizerProps: (0, $kJQf8$reactariautils.mergeProps)(keyboardProps, {
      ...moveProps,
      onKeyDown: onKeyDown
    }, pressProps, {
      style: {
        touchAction: "none"
      }
    }),
    inputProps: (0, $kJQf8$reactariautils.mergeProps)(visuallyHiddenProps, {
      id: id,
      onBlur: () => {
        endResize(item);
      },
      onChange: onChange,
      disabled: isDisabled
    }, ariaProps),
    isResizing: isResizing
  };
}
function $cd66afe5decb6adb$export$6fb1613bd7b28198() {
  return (0, $kJQf8$reactariagrid.useGridRowGroup)();
}